import { Component } from '@angular/core';
import { User } from 'src/app/models/user.model';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tenant-layout',
  imports: [RouterOutlet,RouterModule,CommonModule],
  templateUrl: './tenant-layout.component.html',
  styleUrl: './tenant-layout.component.scss',
})
export class TenantLayoutComponent {
currentRoute: string = '';
  user$: Observable<User | null>;
  constructor(private router: Router, public auth: AuthService){
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => {
    this.currentRoute = event.urlAfterRedirects;
    this.user$ = this.auth.user$;
  });}
  title = 'rental-portal';
   // Navigate to Apply page
   goToApply() {
    this.router.navigate(['/apply']);
  }

  // Navigate to Pay Rent page
  goToPay() {
    this.router.navigate(['/pay']);
  }
  goToLogin() {
    this.router.navigate(['/login']);
  }
  goToDashboard() {
    this.router.navigate(['/tenant']);
  }
  async logout() {
    await this.auth.logout();
    this.router.navigateByUrl('/login');
  }
}
